import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { SolidButtonLink } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "../styles/AppDownload.styles";
export var AppDownloadPanel = function AppDownloadPanel() {
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.panel
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.buttonWrapper
  }, /*#__PURE__*/React.createElement(_StyledSolidButtonLink, {
    compact: true,
    href: "https://notonthehighstreet.onelink.me/XbOV/d531247d",
    rel: "nofollow",
    $_css3: styles.button
  }, "Download our app")));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledSolidButtonLink = /*#__PURE__*/_styled3(SolidButtonLink).withConfig({
  displayName: "AppDownloadPanel___StyledSolidButtonLink",
  componentId: "sc-1nsk6rn-0"
})(["", ""], function (p) {
  return p.$_css3;
});